import { AppServices } from "../../config/entities";
import { IAccountDto } from "../../dtos/accounting/IAccountDto";

export class AccountsService {
  constructor(private catalogName: string) {
    this.catalogName = catalogName;
  }

  async GetAll(searchText: string | undefined): Promise<IAccountDto[]> {
    let url = this.catalogName;

    if (searchText) {
      url += "?searchText=" + searchText;
    }

    const response = await AppServices.Axios.get(url);

    return response.data;
  }

  async Get(id: string): Promise<IAccountDto> {
    const response = await AppServices.Axios.get("accounts/" + id);
    return response.data;
  }
}
